<template>
  <div style="display: flex; justify-content: center;">
    <a-progress
      :stroke-color="label ? '#ff4d4f': '#52c41a'"
      type="circle"
      :percent="defaced_confidence_display"
      status="active"
    >
      <template #format>
        <div>Defacement Confidence:</div>
        <div style="font-size: 21px; font-weight: 600">
          {{ defaced_confidence_display }}%
        </div>
      </template>
    </a-progress>
  </div>
</template>

<script>
export default {
  name: "PredictionResult",
  props: {
    defacedConfidence: {
      type: Number,
      required: true
    },
    defacedThreshold: {
      type: Number,
      required: true
    }
  },
  computed: {
    defaced_confidence_display() {
      return Math.round(this.defacedConfidence * 100);
    },
    label(){
      return this.defacedConfidence > this.defacedThreshold;
    }
  }
};
</script>
